import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, AfterContentInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SelectItem, PrimeTemplate } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';

import { ROWS_PER_PAGE_OPTIONS, AuthService, GrowlService, CommonService, WorkflowService, CacheService, ToolTipService, boolFilter } from '../../../common/service';
import { SensorFailure, SensorFailureColumnModel, AlertStatus } from '../../../common/model';
import { SensorFailureEditComponent } from './sensor-fail-edit.component';
import { SensorFailChartComponent } from './sensor-fail-chart.component';
import { SensorFailuresAuditGridComponent } from './sensor-failures-audit-grid.component';
import { SensorFailureManualAddComponent } from './sensor-failure-manually-add.component';
import { Permission, tooltip } from '../../../common/enum';
import { FilterService } from 'primeng/api';
import { catchError, tap } from 'rxjs/operators';
import { NgIf, NgFor, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, DecimalPipe, DatePipe } from '@angular/common';

import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CheckboxModule } from 'primeng/checkbox';
import { Select } from 'primeng/select';
import { CheckboxComponent } from '../../../../../src/app/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'sensor-failure-management-grid',
  templateUrl: './sensor-failure-management-grid.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, TableModule, PrimeTemplate, TooltipModule,
    FormsModule, ButtonDirective, MultiSelectModule, NgFor, NgStyle, NgSwitch,
    NgSwitchCase, NgSwitchDefault, InputTextModule, ToggleButtonModule, CheckboxModule,
    SensorFailureEditComponent, SensorFailuresAuditGridComponent,
    SensorFailChartComponent, SensorFailureManualAddComponent, DecimalPipe, DatePipe, Select,
    DatePickerModule, CheckboxComponent]
})
export class SensorFailureManagementGridComponent implements OnInit, AfterViewInit {
  @ViewChild('failTable') private _table: Table;
  @ViewChild(SensorFailChartComponent) dataFormRef: SensorFailChartComponent;
  @ViewChild(SensorFailureEditComponent) editFormRef: SensorFailureEditComponent;
  @ViewChild(SensorFailuresAuditGridComponent) auditGridRef: SensorFailuresAuditGridComponent;
  @ViewChild(SensorFailureManualAddComponent) manualGridRef: SensorFailureManualAddComponent;    // here is where i can call methods from my manual page.
  Permission = Permission;
  searchFailures: SensorFailureColumnModel;

  sensorFailStatusFilter: SelectItem[];

  savingFilters = false;
  initialRecordCount: number;// = 0;

  displayGrid: boolean;
  displayEdit: boolean;
  displayData: boolean;
  disabled = true;
  displayManualAdd: boolean;
  globalSearch: string;

  allRows: SensorFailure[];
  alertStatuses: AlertStatus[];
  sensorFailStatusList: SelectItem[] = new Array;
  rows: SensorFailure[] = [];
  initialCount = 0;
  cols: any;
  defaultCols: any[] = [];
  selectedCols: any;

  rowsPerPage: number;
  rowsPerPageOptions = [...ROWS_PER_PAGE_OPTIONS];
  isSaving = false;
  tt: any;
  boolCheckFilter = [...boolFilter];

  constructor(
    private route: ActivatedRoute,
    @Inject(AuthService) public authService: AuthService,
    @Inject(CommonService) public commonService: CommonService,
    @Inject(GrowlService) public growlService: GrowlService,
    private workflowService: WorkflowService,
    @Inject(CacheService) public cacheService: CacheService,
    private filterService: FilterService,
    @Inject(ToolTipService) public toolTipService: ToolTipService
  ) { }

  ngOnInit() {
    this.tt = this.toolTipSetup();
    this.searchFailures = this.cacheService.GetLocal(`Sensor-Failure-Management-Grid-SearchFailures`, new SensorFailureColumnModel);
    this.alertStatuses = this.route.snapshot.data['getAlertStatusResolver'];
    this.rowsPerPage = this.cacheService.GetLocal(`SensorFailureManagementGrid-RowsPerPage`, 10);

    this.allRows = this.route.snapshot.data['getSensorFailures'];
    this.cols = this.getColConfig();
    this.selectedCols = this.cacheService.GetLocal(`SensorFailureManagementGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    this.cacheService.SetLocal('login-lastChoice', 'workflow/fails');
    this.getAlertList();
    this.sensorFailStatusFilter = this.commonService.getFilter(this.sensorFailStatusList, 'label', false);
    this.displayGrid = true;
    this.search();
  }


  exportCSV() {
    const header = new Array;
    for (let index = 0; index < this.selectedCols.length; index++) {
      header.push(this.selectedCols[index].header);
    }
    this.commonService.exportCSV(this.rows, this.selectedCols, header, 'sensor-failure-export', SensorFailure);
  }

  ngAfterViewInit() {
    const _self = this;
    this.filterService.filters['failureDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.searchFailures.failure_date)) {
        return true;
      }

      const failureStartTime: number = _self.searchFailures.failure_date[0].getTime();
      let failureEndTime: number;

      if (_self.searchFailures.failure_date[1]) {
        failureEndTime = _self.searchFailures.failure_date[1].getTime() + 86400000;
      } else {
        failureEndTime = failureStartTime + 86400000;
      }

      return new Date(value).getTime() >= failureStartTime && new Date(value).getTime() <= failureEndTime;
    };

    this.filterService.filters['installationDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.searchFailures.installation_date)) {
        return true;
      }

      const installStartTime: number = _self.searchFailures.installation_date[0].getTime();
      let installEndTime: number;

      if (_self.searchFailures.installation_date[1]) {
        installEndTime = _self.searchFailures.installation_date[1].getTime() + 86400000;
      } else {
        installEndTime = installStartTime + 86400000;
      }

      return new Date(value).getTime() >= installStartTime && new Date(value).getTime() <= installEndTime;
    };

    this.filterService.filters['shippedDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.searchFailures.shipped_date)) {
        return true;
      }

      const shippedStartTime: number = _self.searchFailures.shipped_date[0].getTime();
      let shippedEndTime: number;

      if (_self.searchFailures.shipped_date[1]) {
        shippedEndTime = _self.searchFailures.shipped_date[1].getTime() + 86400000;
      } else {
        shippedEndTime = shippedStartTime + 86400000;
      }

      return new Date(value).getTime() >= shippedStartTime && new Date(value).getTime() <= shippedEndTime;
    };

    if (!this.commonService.isNullOrUndefined(this._table)) {
      if (localStorage.getItem(this._table.stateKey)) {
        const table = JSON.parse(localStorage.getItem(this._table.stateKey));
        table.filters = {};
        localStorage.setItem(this._table.stateKey, JSON.stringify(table));
        this._table.restoreState();
      }
    }
  }

  getAlertList() {
    this.sensorFailStatusList = this.getList(this.alertStatuses, 'status_description', 'alert_status');
  }

  getList(data: any, labelField: string, valueField: string): SelectItem[] {
    const list = new Array;
    list.push({ label: '', value: '' });
    for (let i = 0; i < data.length; i++) {
      list.push({ label: data[i][labelField], value: data[i][valueField] });
    }
    return list;
  }

  add() {
    this.manualGridRef.sensorFailure = new SensorFailure;
    this.manualGridRef.submitted = false;
    this.manualGridRef.loadLists();

    this.displayGrid = false;
    this.displayEdit = false;
    this.displayManualAdd = true;

    this.saveFilters();
  }

  cancelEvent() {
    this.displayManualAdd = false;
    this.displayEdit = false;
    this.displayGrid = true;
    this.restoreFilters();
  }

  clearCols() {
    this.cols = this.getColConfig();
    this.cacheService.SetLocal(`SensorFailureManagementGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    this.selectedCols = this.cacheService.GetLocal(`SensorFailureManagementGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    if (!this.commonService.isNullOrUndefined(this._table)) {
      this._table = this.commonService.resetTableCols(this._table, this.selectedCols, false, true, 0, 2);
    }
  }

  clearFilter(filter) {
    switch (filter) {
      case 'installation_date': {
        this.searchFailures.installation_date = null;
        break;
      }
      case 'failure_date': {
        this.searchFailures.failure_date = null;
        break;
      }
      case 'created_date': {
        this.searchFailures.shipped_date = null;
        break;
      }
    }
    this._table.filter(null, filter, 'in');
  }

  closeData() {
    this.displayData = false;
    this.displayGrid = true;
    this.restoreFilters();
  }

  edit(sensorFailure: SensorFailure) {
    this.editFormRef.sensorFailure = sensorFailure;

    this.editFormRef.loadLists();
    this.editFormRef.showButtons();
    this.editFormRef.submitted = false;

    this.auditGridRef.sensorFailureAudit = null;
    this.auditGridRef.sensorFailureAudit = sensorFailure.sensor_failure_audits;
    this.auditGridRef.show();

    this.displayGrid = false;
    this.displayEdit = true;

    this.displayManualAdd = false;

    this.saveFilters();
  }

  reset() {
    if (!this.commonService.isNullOrUndefined(this._table)) {
      if (localStorage.getItem(this._table.stateKey)) {
        this._table = this.commonService.resetTableFilters(this._table)
      }
    }
    this.rows = null;
    this.searchFailures = new SensorFailureColumnModel;
    this.resetFilters();
    this.search();
  }

  resetFilters() {
    this.sensorFailStatusFilter = this.commonService.getFilter(this.sensorFailStatusList, 'label', false);
    this.searchFailures.installation_date = null;
    this.searchFailures.failure_date = null;
    this.searchFailures.shipped_date = null;
  }

  restoreFilters() {
    this.workflowService.getSensorFailuresSearch().pipe(tap((data) => {
      this.allRows = data;
      this.search();
    }), catchError((error) => {
      this.growlService.error(error);
      return error;
    })).subscribe();
  }

  saveEvent() {
    this.displayEdit = false;
    this.displayGrid = true;
    this.restoreFilters();
    this.search();
  }

  saveFilters() {
    this.savingFilters = true;
    this.searchFailures = this.commonService.setEmptyPropertiesToNull(this.searchFailures);

    this.workflowService.sensorFailureSetCachedSearchCriteria(this.searchFailures).pipe(tap((data) => {
      this.savingFilters = false;
    }), catchError((error) => {
      this.growlService.error(error);
      this.savingFilters = false;
      return error;
    })).subscribe();
  }

  search() {
    this.cacheService.SetLocal(`Sensor-Failure-Management-Grid-SearchFailures`, this.searchFailures);
    this.workflowService.sensorFailureSetCachedSearchCriteria(this.searchFailures)
      .pipe(tap((r) => {
        if (this.initialCount === 0) {
          this.initialCount = r.length;
        }
        this.rows = r;
        if (!this.commonService.isNullOrUndefined(this._table)) {
          this._table.first = 0;
        }
      }), catchError((error) => {
        this.growlService.error(error);
        return error;
      })).subscribe();
  }

  showData(sensorFailure: SensorFailure) {
    this.dataFormRef.sensorFailNumber = sensorFailure.sensor_fail_number;
    this.dataFormRef.drawChart();
    this.displayGrid = false;
    this.displayData = true;
  }

  toolTipSetup() {
    return ({
      tickBoxToolTip: this.toolTipService.filterToolTips(tooltip.tickBox),
      filterToolTip: this.toolTipService.filterToolTips(tooltip.removeFilters),
      rowsVisibleTooltip: this.toolTipService.filterToolTips(tooltip.rowsSelected),
      rowsAvailibleTooltip: this.toolTipService.filterToolTips(tooltip.rowsAvailible),
      columnSelectedTooltip: this.toolTipService.filterToolTips(tooltip.columnsSelected),
      busStopTooltip: this.toolTipService.filterToolTipArray(this.toolTipService.getBusStopArray()),
      resetColumn: this.toolTipService.filterToolTips(tooltip.resetColumn),
      totalRows: this.toolTipService.filterToolTips(tooltip.rowTotal),
      export_All: this.toolTipService.filterToolTips(tooltip.export_All),
      export_Visible: this.toolTipService.filterToolTips(tooltip.export_Visible),
      export_Cols_Rows: this.toolTipService.filterToolTips(tooltip.export_All_Cols_Rows),
      save: this.toolTipService.filterToolTips(tooltip.saveButton),
      cancel: this.toolTipService.filterToolTips(tooltip.cancelButton)
    });
  }

  getColConfig() {
    if (this.authService.isAdministrator()) {
      return [
        { field: 'alert_status_description', header: 'Alert Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'alert_status_description', false), colWidth: '120px' },
        { field: 'pod_serial_number', header: 'Pod Serial', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'pod_serial_number', false), colWidth: '90px' },
        { field: 'pod_status', header: 'Pod Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'pod_status', false), colWidth: '120px' },
        { field: 'sale_type', header: 'Sale Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'sale_type', false), colWidth: '100px' },
        { field: 'sensor_serial_number', header: 'Sensor Serial', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '133px' },
        { field: 'sensor_type', header: 'Sensor Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'sensor_type', false), colWidth: '55px' },
        { field: 'failure_date', header: 'Failure Date', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'fail_reason', header: 'Fail Reason', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'fail_reason', false), colWidth: '120px' },
        { field: 'location_name', header: 'Pod Location', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'location_name', false), colWidth: '120px' },
        { field: 'project_name', header: 'Project', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'project_name', false), colWidth: '200px' },
        { field: 'owner_name', header: 'Owner', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'owner_name', false), colWidth: '200px' },
        { field: 'distributor_name', header: 'Distributor', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'distributor_name', false), colWidth: '200px' },
        { field: 'installation_date', header: 'Date Fitted', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '75px' },
        { field: 'age_in_months', header: 'Age in months', isHidden: true, isReadonly: true, datatype: 'number', colWidth: '65px' },
        { field: 'replacement_sensor_serial', header: 'Replacement Sensor Serial', isHidden: true, isReadonly: true, datatype: 'number', colWidth: '145px' },
        { field: 'false_positive', header: 'False positive', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'false_positive', false), colWidth: '50px', maxLength: 0 },
        { field: 'fail_confirmed', header: 'Failure confirmed', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'fail_confirmed', false), colWidth: '50px', maxLength: 0 },
        { field: 'shipped', header: 'Sensor shipped', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'shipped', false), colWidth: '50px', maxLength: 0 },
        { field: 'shipped_date', header: 'Date Sensor Shipped', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'not_needed', header: 'Customer does not need replacement sent', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'not_needed', false), colWidth: '50px', maxLength: 0 },
        { field: 'not_required', header: 'E.I. to replace (Failed sensor)', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'not_required', false), colWidth: '50px', maxLength: 0 },
        { field: 'ship_sensors_to_owner', header: 'Ship Sensors to Owner', isHidden: false, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'ship_sensors_to_owner', false), colWidth: '50px', maxLength: 0 },
        { field: 'block_sending_sensors', header: 'Block Sending Sensors', isHidden: false, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'block_sending_sensors', false), colWidth: '50px', maxLength: 0 }
      ];
    } else {
      return [
        { field: 'pod_serial_number', header: 'Pod Serial', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'pod_serial_number', false), colWidth: '120px' },
        { field: 'pod_status', header: 'Pod Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'pod_status', false), colWidth: '90px' },
        { field: 'location_name', header: 'Pod Location', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'location_name', false), colWidth: '200px' },
        { field: 'project_name', header: 'Project', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'project_name', false), colWidth: '3px' },
        { field: 'owner_name', header: 'Owner', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'owner_name', false), colWidth: '508px' },
        { field: 'distributor_name', header: 'Distributor', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'distributor_name', false), colWidth: '538px' },
        { field: 'sensor_serial_number', header: 'Sensor Serial', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '65px' },
        { field: 'sensor_type', header: 'Sensor Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'sensor_type', false), colWidth: '70px' },
        { field: 'failure_date', header: 'Failure Date', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'installation_date', header: 'Date Fitted', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'age_in_months', header: 'Age in months', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '145px' },
        { field: 'alert_status_description', header: 'Alert Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.allRows, 'alert_status_description', false), colWidth: '80px' },
        { field: 'replacement_sensor_serial', header: 'Replacement Sensor Serial', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '145px' },
        { field: 'false_positive', header: 'False positive', isHidden: false, isReadonly: true, isDisabled: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'false_positive', false), colWidth: '100px', maxLength: 0 },
        { field: 'fail_confirmed', header: 'Failure confirmed', isHidden: false, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'fail_confirmed', false), colWidth: '100px', maxLength: 0 },
        { field: 'shipped', header: 'Sensor shipped', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'shipped', false), colWidth: '130px' },
        { field: 'shipped_date', header: 'Date Sensor shipped', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'not_needed', header: 'Customer does not need replacement sent', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'not_needed', false), colWidth: '100px', maxLength: 0 },
        { field: 'not_required', header: 'E.I. to replace (Failed sensor)', isHidden: true, isReadonly: true, datatype: 'boolean', filter: this.commonService.getFilter(this.allRows, 'not_required', false), colWidth: '100px', maxLength: 0 },
      ];
    }
  }

  setPreferences() {
    this.cacheService.SetLocal(`SensorFailureManagementGrid-RowsPerPage`, this.rowsPerPage);
    this.cacheService.SetLocal(`SensorFailureManagementGrid-SelectedCols`, this.selectedCols);
    this._table = this.commonService.resetTableCols(this._table, this.selectedCols, false, true, 0, 2);

  }

  has(requiredPermissions: Permission | Permission[]) {
    return this.authService.hasPermission(requiredPermissions);
  }


  boolfilterRow(field: string, value?: boolean | string) {
    const filter = this.commonService.boolFilter(field, this.searchFailures, false, this._table, value);

    this.searchFailures = filter.model;
    this.tt = filter.table;
  }
}
